import { EarlyBird, Cloud, Overnight } from 'pcln-icons'

const TAKEOFF_TIMES = {
  early_morning: 'between 12a-5a',
  morning: 'between 5a-12p',
  mid_day: 'between 12p-6p',
  afternoon: 'between 12p-6p',
  evening: 'between 6p-9p',
  night: 'between 9p-12a',
}

const TAKEOFF_ICONS = {
  early_morning: EarlyBird,
  morning: EarlyBird,
  mid_day: Cloud,
  afternoon: Cloud,
  evening: Overnight,
  night: Overnight,
}

const DEFAULT_AIRLINES_DESCRIPTION = 'Trusted airlines - exclusive deals'

export { TAKEOFF_TIMES, TAKEOFF_ICONS, DEFAULT_AIRLINES_DESCRIPTION }
